
import 'swiper/swiper.min.css'
import AdminContentEditable from '~/mixins/AdminContentEditable'
import ContentCreator from '../HeocademySiteBuilder/ContentCreator.vue'
import RemoveContent from '../HeocademySiteBuilder/RemoveContent.vue'
export default {
  mixins: [AdminContentEditable],
  components: {
    RemoveContent,
    ContentCreator,
  },
  props: {
    title: {
      default: 'referances',
    },
  },
  data() {
    const vm = this
    return {
      showCreator: false,
      removeContentItem: { show: false, id: -1 },
      activeIndex: 0,
      swiperOption: {
        autoplay: 1500,
        slidesPerView: 5,
        loop: false,
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 50,
          },
        },
        onSlideChangeEnd: (swiper) => {
          // can do something
          if(vm) vm.activeIndex = swiper.activeIndex
        },
      },
      sponsorList: this.$store.state.settings.contents.sponsorList,
    }
  },
  methods: {
    UPDATE_CONTENT(id) {
      const index = this.sponsorList.findIndex((s) => s.id === id)
      if (index > -1)
        this.$store.commit('REMOVE_TO_CONTENT', {
          key: 'sponsorList',
          index,
          id,
        })
      this.removeContentItem = false
    },
  },
  mounted() {},
}
